import(/* webpackMode: "eager" */ "/vercel/path0/app/build/page.tsx");
